import { useEffect, useMemo, useState } from "react";

/** Paginação client-side: garante que só 20 linhas fiquem no DOM por vez.
 *  Reseta pra página 1 sempre que a lista muda (filtro/busca). */
export function usePagination(items, pageSize = 20) {
  const [page, setPage] = useState(1);
  const total = items?.length || 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  // Se a lista encolheu abaixo da página atual, volta pra 1.
  useEffect(() => {
    if (page > totalPages) setPage(1);
  }, [total, totalPages, page]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return (items || []).slice(start, start + pageSize);
  }, [items, page, pageSize]);

  return { pageItems, page, setPage, totalPages, total };
}
